import { request } from '@/utils/request';
import {
  ReqBankListParams,
  ReqBranchBankListParams,
  ReqSupplierAccountListParams,
  ReqSupplierListParams,
  SaveSupplierBankCardParams,
} from './entities';

/**
 * 开户银行列表
 * @param params
 * @returns
 */
export async function reqBankList(params?: ReqBankListParams) {
  return request('/zlb/api/pay/bankCard/bank/list', {
    params,
  });
}

/**
 * 开户支行列表
 * @param params
 * @returns
 */
export async function reqBranchBankList(data: ReqBranchBankListParams) {
  return request('/zlb/api/pay/bankCard/bank/branch/list', {
    method: 'POST',
    data,
  });
}

/**
 * 查询供应商名称列表
 */
export async function reqSupplierList(params: ReqSupplierListParams) {
  return request('/zlb/api/pay/bankCard/querySupplierList', {
    params,
  });
}

/**
 * 查询供应商（单位、个人）对公、对私银行卡列表
 */
export async function reqSupplierAccountList(params: ReqSupplierAccountListParams) {
  return request('/zlb/api/pay/bankCard/queryPageSupplierAccount', {
    params,
  });
}

/**
 * 查询供应商（单位、个人）对公、对私银行卡列表 —— 一般事项新增
 */
export async function reqSupplierAccountListNew(params: ReqSupplierAccountListParams) {
  return request('/zlb/api/pay/bankCard/queryAllSupplierAccount', {
    params,
  });
}

/**
 * 保存供应商（单位、个人）对公、对私银行卡
 */
export async function saveSupplierBankCard(data: SaveSupplierBankCardParams) {
  return request('/zlb/api/pay/bankCard/saveSupplierBankCard', {
    method: 'POST',
    data,
  });
}

/**
 * 删除个人银行卡/解绑公务卡
 */
export async function deleteSupplierBankCard(params: string) {
  return request(`/zlb/api/pay/bankCard/delete/${params}`, {
    method: 'POST',
  });
}

/**
 * 获取开户银行列表
 * @param params
 * @returns
 */
export async function getSpecifiedLevelTree(params) {
  return request('/api/user/address/specifiedLevelTree', {
    params,
  });
}

/**
 * 查询开户支行是否必填
 * @param data
 * @returns
 */
export async function getBankBranchConfig(data) {
  return request('/zlb/api/pay/config/query-bank-branch-config', {
    method: 'POST',
    data,
  });
}

/**
 * 根据accountCode查询银行卡详情
 */
export async function fetchAccountDetail(accountCode) {
  return request(`/zlb/api/pay/bankCard/detail/${accountCode}`);
}

/**
 * 获取收款/供应商详情
 */
export function getSupplierBankDetail(data) {
  return request('/zlb/api/expense/common/getBankInfo', {
    method: 'POST',
    data,
  });
}
